export default __webpack_public_path__ + "static/media/image-ph-health-briefing-w@2x.8edc078d.webp";